<template>
  <div class="depart_manage" :style="screenHeight">
    <div class="left_tree" style="overflow: hidden">
      <div style="width: 100%;height: 30px;border-top: 1px #c4c4c4 solid;border-bottom: 1px #c4c4c4 solid;
              display: flex;justify-content: center;align-items: center;">
        <span style="font-weight: 700;">工单类型</span>
      </div>
      <div  style="width: 100%;overflow: hidden auto;position: relative;" :style="leftHeight">
        <ul v-if="inspectTreeData && inspectTreeData.length>0">
          <li v-for="(item,index) in inspectTreeData" :key="index"><A :class="{'hover' : index==0}" href="javascript:void(0)" :title="item.dictValue" @click="searchGroup(item.id)">{{item.dictValue}}</A></li>
        </ul>
      </div>

      <!--      <ul id="groupTree" class="ztree" style="width:100%;overflow:auto;height: 94%;"></ul>-->
    </div>
    <div class="fixed_table">
      <div style="width: 100%;height: 30px;border-top: 1px #c4c4c4 solid;border-bottom: 1px #c4c4c4 solid;
              display: flex;justify-content: center;align-items: center;">
        <span style="font-weight: 700;padding-right: 8px;">表单字段设置</span>
        <Tooltip class="tips_font" placement="bottom"><img :src="questionMark"/>
          <div slot="content">
            工单对应的类型，比如: 事件、咨询、任务等，不同类型的工单可支持展示不同的自定义字段。
          </div>
        </Tooltip>
      </div>
      <Spin size="large" fix v-if="spinShow">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>正在加载中...</div>
      </Spin>


      <div class="footer_style" :style="tableHeight">
        <div class="submitTicketSet" style="width: 100%;height: 87%;overflow: auto;padding: 30px;">
          <ul>
            <li :title="item.name" v-for="(item,index) in infoTableList" :key="index"
                style="display:inline-block;margin-right:35px" :class="{true: 'activeShow'}[item.isSelect=='1']"
                @click="checkedMenu(item,index)">
              {{item.name}}
              <img v-show="item.isSelect == '1' " src="@/assets/image/workOrder/checked.png">
            </li>
          </ul>
        </div>
        <div
          style="width: 95%;height: 10%;margin-top: 1%;display: flex;align-items: center;border-top: 1px #c4c4c4 solid;">
          <div class="btn_template">
            <Button type="primary" class="submit_btn" v-show="roleList['3_d-2-1']" @click="save()">保存</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  import $ from "jquery";

  export default {
    name: "WorkOrderExtensionForm",
    mixins: [publicFunClass],
    props: {
      pageCode: String
    },
    data() {
      return {
        questionMark: require('../../../assets/image/homeAsk.png'),
        showPageCount: 0,
        roleList: JSON.parse(localStorage.getItem("roleList")),
        spinShow: false,
        showGroup: false,
        infoTableList: [],
        screenHeight: {height: ''},
        tableHeight: {height: ''},
        inspectTreeData: [],
        journalType: '',
        menuId: '',
        selectedTreeId: '',
        leftHeight: {height: ''},
      }
    },
    methods: {
      save: function () {
        let that = this;
        that.$Modal.confirm({
          title: '提示',
          content: "是否确定保存",
          onOk: () => {
            let newList = [];
            for (let i = 0; i < that.infoTableList.length; i++) {
              if ('1' == that.infoTableList[i].isSelect) {
                newList.push(that.infoTableList[i].id);
              }
            }
            let param = {
              journalType: "系统管理=>工单配置=>工单扩展表单=>保存",
              menuId: "3_d-2-1",
              dictionaryId: that.selectedTreeId,
              customIds: newList.toString(),
            };
            this.$http.post("orderExtend/doSave.json", param).then(function (res) {
              let result = res.data.flag;
              if (result != "666") {
                that.$Modal.info({
                  title: '提示',
                  content: res.data.msg
                });
                return false;
              }
              that.$Message.info("操作成功");
              that.searchGroup(that.selectedTreeId);
            });
          }
        });
      },
      checkedMenu: function (item, index) {
        if (item.isSelect == '0') {
          this.infoTableList[index].isSelect = '1';
        } else {
          this.infoTableList[index].isSelect = '0';
        }
        this.$forceUpdate();
      },
      initSearch: function () {
        let param = {
          journalType: "系统管理=>工单配置=>工单扩展表单=>工单状态查询",
          menuId: "",
        };
        let that = this;
        this.$http.post("orderExtend/toLeftOrderTypeList.json", param).then(function (res) {
          let result = res.data.flag;
          if (result != "666") {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }
          let list = res.data.obj.list;
          if (list == "") {
            that.infoTableList = [];
          }
          that.inspectTreeData = list;
          that.selectedTreeId = list[0].id;
          that.searchGroup(list[0].id);
          that.$nextTick(() => {
            that.lll();
          })

        });
      },
      searchGroup: function (id) {
        this.selectedTreeId = id;
        let param = {
          dictionaryId: id,
          journalType: "null",
          menuId: "null"
        };
        let that = this;
        this.$http.post("orderExtend/toRightFieldList.json", param).then(function (res) {
          let result = res.data.flag;
          if (result != "666") {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }
          that.infoTableList = res.data.obj.list;
        });
      },
      lll:function () {
        $('.left_tree ul li').click(function () {
          let length = $('.left_tree ul li').length;
          for (var i = 0; i < length; i++) {
            if (this == $('.left_tree ul li').get(i)) {
              $('.left_tree ul li').eq(i).children('a').addClass('hover');
            } else {
              $('.left_tree ul li').eq(i).children('a').removeClass('hover');
            }
          }
        })
      }
    },
    updated(){
    },
    created() {
      this.screenHeight.height = this.mountHeight(91);
      this.tableHeight.height = this.mountHeight(151);
      this.initSearch();
    },
    mounted() {
      this.$nextTick(() => {
        let clientHeight=document.documentElement.clientHeight;
        let actualHeight=clientHeight-125+'px';
        this.leftHeight.height = actualHeight;
      })
    },
    watch: {
      pageCode: function () {
        // if(this.pageCode=='3_12-3' && this.showPageCount==0){
        //   this.showPageCount++;
        //   this.initSearch();
        // }
      }
    }
  }
</script>

<style scoped>
  .submitTicketSet li {
    width: 128px;
    border: 1px solid #ccc;
    height: 35px;
    text-align: center;
    line-height: 34px;
    border-radius: 5px;
    margin-bottom: 20px;
    cursor: pointer;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    list-style: none;
    position: relative;
  }

  .submitTicketSet li:hover {
    text-decoration: none;
    background: #f2f2f2;
    border: none;
  }

  .submitTicketSet .activeShow {
    background: #f2f2f2;
    border: none;
  }

  .submitTicketSet li img {
    position: absolute;
    right: 0;
    top: 0;
  }

  .left_tree ul {
    width: 97%;
    margin: 0 auto;
    background: #fff;
    z-index: 0;
  }

  .left_tree ul li {
    width: 100%;
    overflow: hidden;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-bottom: 1px solid #F8F8F8;
  }

  .left_tree ul li a {
    color: #666;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .left_tree ul li a:hover {
    color: #2d8cf0;
    background: #F8F8F8;
    text-decoration: none;
  }

  .left_tree ul li a.hover {
    color: #2d8cf0;
    background: #F8F8F8;
  }

  html, body, div, span, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, abbr, address, cite, code, del, dfn, em, img, ins, kbd, q, samp, small, strong, sub, sup, var, b, i, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, figcaption, figure, footer, header, hgroup, menu, nav, section, summary, time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    font-size: 100%;
    vertical-align: baseline;
    background: transparent;
    font-weight: normal;
  }

  body {
    line-height: 1;
  }

  :focus {
    outline: 1;
  }

  article, aside, canvas, details, figcaption, figure, footer, header, hgroup, menu, nav, section, summary {
    display: block;
  }

  nav ul, ul, li {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before, blockquote:after, q:before, q:after {
    content: '';
    content: none;
  }

  a {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    vertical-align: baseline;
    background: transparent;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  ins {
    background-color: #ff9;
    color: #000;
    text-decoration: none;
  }

  mark {
    background-color: #ff9;
    color: #000;
    font-style: italic;
    font-weight: bold;
  }

  del {
    text-decoration: line-through;
  }

  abbr[title], dfn[title] {
    border-bottom: 1px dotted #000;
    cursor: help;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #cccccc;
    margin: 1em 0;
    padding: 0;
  }

  input, select {
    vertical-align: middle;
  }

  .fl {
    float: left;
    display: inline-block;
  }

  .fr {
    float: right;
    display: inline-block;
  }

  .clearfix:after {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: " ";
    clear: both;
    height: 0;
  }

  .clearfix {
    display: inline-table;
  }

  * html .clearfix {
    height: 1%;
  }

  .clearfix {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/systemSetup/worknote/WorkOrderExtensionForm.vue